import ascommon from "./ascommon";
import $ from "jquery";
import "bootstrap";
import moment from "moment";

export class SessionManager {
    private $logoutCounterDialog: JQuery;
    private $autoLogoutCounter: JQuery;
    private $autoLogoutDiv: JQuery;
    private $logoutCounter: JQuery;
    private $logoutText: JQuery;
    private $asMenu: JQuery;

    private logoutTime: number;
    private logoutSeconds: number;
    private logoutCounter: number;
    private logoutTimer: NodeJS.Timeout;
    private sessionTimer: NodeJS.Timeout; // pings home to the server to maintain session state
    private logoutCounterVisible: boolean;
    private userTouched: boolean;
    private userTouched1: boolean;
    private asMenuShown: boolean;
    private currentPage: string;
    private visitWorker: Worker;

    constructor() {
        const that = this;

        this.currentPage = window.location.pathname.toLowerCase().substring(1);

        if (!window.MainWorklist) {
            this.visitWorker = new Worker('/Scripts/Compiled/VisitWorker.js');
        }

        // Activity listeners
        $(document).on('mousedown', function (event: JQuery.MouseDownEvent) {
            // Stop the log dump process now that the user is reengaging with the app
            if (that.visitWorker) {
                that.visitWorker.postMessage({ type: "StopSendingLogs" });
            }

            if (window.parent && window.parent.name === 'ivWindow' && event.target && event.target.className === 'focus') {
                // case 15555
            } else {
                if (window.SendCommandToLauncher) {
                    window.SendCommandToLauncher('runMethodOnMain', 'sessionManager.userTouchedFromLauncher', 'document.mousedown');
                }

                if (event.target) {
                    ascommon.log("document.mousedown on element " + event.target.id);
                } else {
                    ascommon.log("document.mousedown (no event.target)");
                }
            }

            if (window.opener && window.name !== 'mainWindow') {
                window.opener.sessionManager.userTouched = true;
            } else {
                that.userTouched = true;
                that.userTouched1 = true;
            }

            if (document.activeElement && ($(document.activeElement).hasClass("trumbowyg-editor") || $(document.activeElement).hasClass("fr-view"))) {
                var sel = window.getSelection();
                if (sel.getRangeAt && sel.rangeCount) {
                    window.currentSelection = sel.getRangeAt(0);
                }
                else {
                    window.currentSelection = null;
                }
            }
        });

        $(document).on('keydown', function (event: JQuery.KeyDownEvent) {
            // Stop the log dump process now that the user is reengaging with the app
            if (that.visitWorker) {
                that.visitWorker.postMessage({ type: "StopSendingLogs" });
            }

            if (window.SendCommandToLauncher) {
                window.SendCommandToLauncher('runMethodOnMain', 'sessionManager.userTouchedFromLauncher', 'document.keydown');
            }
            var elm = event.target ? event.target.id : " no event target";
            ascommon.log("document.keydown on element: " + elm);
            if (window.opener && window.name !== 'mainWindow') {
                window.opener.sessionManager.userTouched = true;
            } else {
                that.userTouched = true;
                that.userTouched1 = true;
            }
        });

        // login page only needs activity tracking and upon reaching the login page start dumping logs immediately
        if (this.currentPage === Pages.login) {
            this.visitWorker.postMessage({ type: "SendLogs" });
            this.unregisterServices();
            return;
        }

        // Session listeners
        $(document).ready(function() {
            // Had to use jQuery here instead of $ because modal is not binding correctly to $.
            // I think this is because we have multiple jQuery libraries referenced at once.
            that.$logoutCounterDialog = jQuery("#logoutCounterDialog");
            that.$autoLogoutCounter = jQuery("#autoLogoutCounter");
            that.$autoLogoutDiv = jQuery("#autoLogoutDiv");
            that.$logoutCounter = jQuery("#logoutCounter");
            that.$logoutText = jQuery("#logoutText");
            that.$asMenu = jQuery('#asMenu');

            if (!that.logoutTime) {
                that.logoutTime = Date.now() + 20 * 60 * 1000; //20 min
            }

            that.$logoutCounterDialog.on("show.bs.modal", function () {
                try {
                    that.logoutCounterVisible = true;
                    // case 16048, 16069
                    if ($("#reportPreviewDialog").hasClass("in")) $("#reportPreviewDialog #reportPreview").hide();
                    if (window.spellcheckInProgress) $(".dxwsc-main").hide();
                    if (that.$asMenu.is(':visible')) {
                        that.$asMenu.hide();
                    }
                }
                catch (err) {
                    ascommon.log("logoutCounterDialog.show() - " + err.message);
                }
            });

            that.$logoutCounterDialog.on("hide.bs.modal", function () {
                try {
                    that.logoutCounterVisible = false;
                    // case 16048, 16069
                    if ($("#reportPreviewDialog").hasClass("in")) $("#reportPreviewDialog #reportPreview").show();
                    if (window.spellcheckInProgress) $(".dxwsc-main").show();
                    if (that.$asMenu.is(':visible')) {
                        that.$asMenu.show();
                    }
                }
                catch (err) {
                    ascommon.log("logoutCounterDialog.hide() - " + err.message);
                }
            });

            that.$logoutCounterDialog.on('mousedown', function () {
                that.HideAutologoutCounter();
            });

            that.$logoutCounterDialog.on('keydown', function () {
                that.HideAutologoutCounter();
            });

            that.unregisterServices();
        });

        if (!that.sessionTimer) {
            that.sessionTimer = setInterval(() => that.KeepSessionAlive(), 60000); // 1 min
        }
    }

    public SetAutoLogout(seconds: number) {
        let that = this;

        this.logoutSeconds = seconds;
        this.logoutTime = Date.now() + seconds * 1000;

        if (this.logoutTime) {
            this.logoutCounter = 0;
            if (this.logoutTimer) clearInterval(this.logoutTimer);
            this.logoutTimer = setInterval(() => that.checkUserActivity(), 10000); // 10 sec
            ascommon.log("AutoLogout: Set logoutTimer for " + seconds + " seconds");
        }
    }

    public logOut(source: string) {
        // save any state before killing our session
        if (window.activeUser && window.isHiddenVisitShown) {
            if (window.activeSection && window.canLeaveSection(window.activeSection)) {
                let $template = jQuery('#' + window.templateName);
                if (window.focusedFieldId !== undefined && window.focusedFieldId !== null && window.focusedFieldId !== '') {
                    window.MDicBlurFunction($template.find('#' + window.focusedFieldId).get(0));
                }
                const scope = $template.scope() as IEditModeControllerScope;
                if (scope && scope.selectedGrid)
                {
                    scope.resetGrid();
                }

                if (validateVisit())
                    window.SaveTemplate(window.templateId);
            }

            if (window.isNewDemographics && !window.ValidatePatientName()) {
                window.abortPatientInBackground();
            }
        }

        ascommon.log("Starting Logout attempt: User " + (window.activeUser ? window.activeUser.UserID : "Anonymous") + ", Source " + source + ", Time " + moment().format('MM/DD/YYYY'));

        this.clearWindowsOnLogout();
        this.abortAllRequests();
        WorklistTimer.HideWorklist();

        window.SendCommandToLauncher('logOut', '');

        window.activeUser = null;
        ascommon.ajax(
            '/Account/LogOut',
            { caller: source },
            (success) => {
                window.SendCommandToLauncher("shutdown");
            },
            null,
            "POST",
            false
        );

        window.clearTemplateStorage();
        this.ClearTimers();
        $('#asMenu').css('display', 'none');
        if (source === "serverErrorDialog") {
            window.SendCommandToLauncher('closeLauncher', '');
        }

        window.location.href = "/login";
    }

    public abortAllRequests() {
        window.ascommon.log("abortAllRequests: requests number in pool: " + window.xhrPool.length);

        $.each(window.xhrPool, function(idx, jqXHR) {
            jqXHR.abort();
            window.ascommon.log("Request aborted: " + jqXHR.responseURL);
        });
    }

    public clearWindowsOnLogout() {
        ascommon.log('clearWindowsOnLogout: call to clearWindowsOnLogout');

        window.sessionStorage.setItem("splitterLeftPanelWidth", '');
        var isIVOpened = window.sessionStorage.getItem("isIVOpened");
        if (isIVOpened === "true") {
            var iv = window.getImageViewerWindow();
            iv.close();
        }
    }

    public ClearTimers() {
        if (this.sessionTimer) clearInterval(this.sessionTimer);
        if (this.logoutTimer) clearInterval(this.logoutTimer);
    }

    public userTouchedFromLauncher() {
        this.userTouched = true;
        this.userTouched1 = true;
    }

    public HideAutologoutCounter() {
        window.SendCommandToLauncher('runMethodOnMain', 'sessionManager.HideAutologoutCounterOnMaster');

        if (window.opener && window.name !== 'mainWindow') {
            window.opener.sessionManager.HideAutologoutCounterOnMaster();
        } else {
            clearInterval(this.logoutTimer);
            ascommon.log('HideAutologoutCounter: cleared LogoutTimer');
            this.$logoutCounterDialog.modal("hide");
            this.HideAutologoutChildrenCounter();
            this.SetAutoLogout(window.activeUser.Settings.AutoLogoffInterval * 60);
        }
    }

    private KeepSessionAlive() {
        ascommon.ajax("/Account/KeepSessionAlive", null, null);
    }

    /*
     * The intention of this function is to make sure workers don't get stuck with cached code for too long.
     * The unregistered services will still function until the user closes the tabs it is registered to.
     * Workers should be re-instantiated every time a page that needs them loads.
     * https://developer.mozilla.org/en-US/docs/Web/API/Service_Worker_API/Using_Service_Workers#updating_your_service_worker
     */
    private unregisterServices() {
        navigator
            .serviceWorker
            .getRegistration()
            .then((serviceWorker) => {
                if (serviceWorker) {
                    serviceWorker.unregister();
                }
            })
            .catch((error) => {
                console.error("Failed to unregister serviceworker: ", error);
            });
    }

    private checkUserActivity() {
        let that = this;

        if (that.userTouched) {
            that.logoutCounter = 0;
            that.logoutTime = Date.now() + that.logoutSeconds * 1000;
            that.userTouched = false;
        } else {
            that.logoutCounter++;
        }

        // Autosave after first min on inactivity
        if (that.logoutCounter === 6) {
            if (typeof window.SaveTemplate === "function") {
                ascommon.log("Initiating visit save due to user inactivity")
                if (window.isHiddenVisitShown) {
                    var focusedElement = $(":focus");
                    if (focusedElement.length > 0) {
                        focusedElement.trigger("blur");
                    }
                }
                window.SaveTemplate(window.templateId);
            }

            // Start sending logs while the user is inactive
            if (that.visitWorker) {
                that.visitWorker.postMessage({ type: "SendLogs" });
            }
        }

        if ((that.logoutTime - 180 * 1000) < Date.now()) { //if less than 3 min left
            clearInterval(that.logoutTimer);
            that.logoutCounter = 181; // 3 min
            that.updateLogoutCounter(that.logoutTime);
            that.prepareCounter();
            that.showCounter();
            that.logoutTimer = setInterval(() => that.updateLogoutCounter(that.logoutTime), 1000);

            if (!window.opener || window.name === 'mainWindow') {
                window.SendCommandToLauncher('runMethodOnIV', 'sessionManager.prepareCounter');
                window.SendCommandToLauncher('runMethodOnIV', 'sessionManager.showCounter');

                var isIVOpened = sessionStorage.getItem("isIVOpened");
                if (isIVOpened === "true") {
                    var iv = window.getImageViewerWindow();
                    if (iv && !iv.closed) {
                        iv.sessionManager.prepareCounter();
                        iv.sessionManager.showCounter();
                    }
                }
            }
        }
    }

    private showCounter() {
        this.$logoutCounterDialog.modal({ keyboard: false });
    }

    private prepareCounter() {
        this.$autoLogoutCounter.closest(".modal-body").css("height", "100%");
        this.$autoLogoutCounter.css("left", "50%");
        this.$autoLogoutCounter.css("margin-left", "-200px");
        this.$autoLogoutCounter.css("top", "50%");
        this.$autoLogoutCounter.css("margin-top", "-200px");

        this.$autoLogoutDiv.css("margin-top", 180);
        this.$logoutText.text(window.StringResources.Logout_LoggingOutIn);
    }

    private HideAutologoutCounterOnMaster() {
        clearInterval(this.logoutTimer);
        ascommon.log('HideAutologoutCounterOnMaster: cleared LogoutTimer');
        this.HideCounterOnCurrentPage();
        this.HideAutologoutChildrenCounter();
        this.SetAutoLogout(window.activeUser.Settings.AutoLogoffInterval * 60);
    }

    private HideCounterOnCurrentPage() {
        this.$logoutCounterDialog.modal("hide");
    }

    private HideAutologoutChildrenCounter() {
        if (!window.opener || window.name === 'mainWindow') {
            window.SendCommandToLauncher('runMethodOnIV', 'sessionManager.HideCounterOnCurrentPage');

            var isIVOpened = window.sessionStorage.getItem("isIVOpened");
            if (isIVOpened === "true") {
                var iv = window.getImageViewerWindow();
                if (iv && !iv.closed) {
                    iv.sessionManager.HideCounterOnCurrentPage();
                }
            }
        }
    }

    private updateLogoutCounter(logoutTime: number) {
        const that = this;

        that.logoutCounter--;
        var now = Date.now();

        if (now < logoutTime) {
            const milliseconds = logoutTime - now;
            const min = Math.floor(milliseconds / 60000);
            const sec = Math.floor((milliseconds % 60000) / 1000);
            const timeFormatted = min + ":" + (sec < 10 ? "0" + sec : sec);

            that.$logoutCounter.text(timeFormatted);

            if ((!window.opener || window.name === 'mainWindow') && window.name !== "ivWindow") {
                ascommon.log("SessionManager: windowname - " + window.name);
                window.SendCommandToLauncher('updateLogoutCounter', logoutTime.toString());
                var isIVOpened = window.sessionStorage.getItem("isIVOpened");
                if (isIVOpened === "true") {
                    var iv = window.getImageViewerWindow();
                    if (iv && !iv.closed) {
                        iv.sessionManager.$logoutCounter.text(timeFormatted);
                    }
                }
            }
        }
        else {
            clearInterval(that.logoutTimer);
            ascommon.log('updateLogoutCounter: cleared LogoutTimer - going to logout!');
            that.$logoutText.text(window.StringResources.Logout_LoggingOut);
            that.$logoutCounter.text("");
            // if in visit then come back to worklist
            if (window.isHiddenVisitShown) {
                window.refreshWorklistOnExit = false;
                window.GoToWorklist(false, false, true);
            }

            that.asMenuShown = false;
            that.HideAutologoutChildrenCounter();
            jQuery(".modal.in").modal("hide");

            that.logOut("AutoLogOff");
        }
    }
}

enum Pages {
    login ="login",
    worklistview = "worklistview",
    imageviewer = "imageviewer"
}

export default SessionManager;
// for main thread this is window, for workers this is the WorkerGlobalScope
self.SessionManager = SessionManager;

self.sessionManager = new SessionManager(); // the instance for the window
